var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCurrencyPoundBlack(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h24v24H0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 2.25c5.385 0 9.75 4.365 9.75 9.75a9.75 9.75 0 0 1-19.5 0c0-5.385 4.365-9.75 9.75-9.75zm0 1.5a8.25 8.25 0 1 0 0 16.5 8.25 8.25 0 0 0 0-16.5zm-1.248 2.464a3.75 3.75 0 0 1 3.9.885.75.75 0 0 1-1.061 1.06 2.25 2.25 0 0 0-2.34-.53A2.244 2.244 0 0 0 9.765 9.49c-.013.15-.006.302.022.47l.184 1.29H12a.75.75 0 0 1 .745.663l.005.087a.75.75 0 0 1-.75.75h-1.814l.107.75c.076.53.07 1.064-.014 1.585l-.04.21.063-.02a3 3 0 0 1 1.71-.055l.186.055.655.219A1.5 1.5 0 0 0 14 15.412l.666-.333a.75.75 0 1 1 .67 1.342l-.666.333a3 3 0 0 1-2.29.163l-.655-.218a1.5 1.5 0 0 0-.948 0l-1.539.513a.75.75 0 0 1-.908-1.046l.121-.244a3.75 3.75 0 0 0 .359-2.209l-.138-.964-.421.001a.75.75 0 0 1-.745-.663L7.5 12a.75.75 0 0 1 .75-.75h.206l-.15-1.058a3.28 3.28 0 0 1-.046-.625l.011-.217a3.75 3.75 0 0 1 2.481-3.136z",
    fill: "#192340",
    fillRule: "nonzero"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCurrencyPoundBlack);
export default __webpack_public_path__ + "static/media/currency-pound-black.6a41c3e8ad413cf6f57f4e007b2252ea.svg";
export { ForwardRef as ReactComponent };